import { useEffect, useState } from "react";
import { getCautionFeeDetails } from "@services/krent.service";
import RefundRequestModal from "../pages/CautionFeeDetails/RefundRequestModal";
import "../pages/CautionFeeDetails/CautionFeeDetails.css";

interface Props {
  transactionId: string;
}

export default function CautionFeeRefundButton({ transactionId }: Props) {
  const [canRequestRefund, setCanRequestRefund] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    setCanRequestRefund(false);
    getCautionFeeDetails(transactionId, abortController.signal)
      .then((res: any) => {
        if (!abortController.signal.aborted) {
          setCanRequestRefund(Boolean(res?.data?.canRequestRefund));
        }
      })
      .catch(() => {});

    return () => abortController.abort();
  }, [transactionId]);

  return (
    <>
      {canRequestRefund && (
        <div className="d-flex justify-content-end mt-3">
          <button
            type="button"
            className="cfd-request-button"
            onClick={() => setShowModal(true)}
          >
            Request caution fee refund
          </button>
        </div>
      )}
      {showModal && (
        <RefundRequestModal
          transactionId={transactionId}
          onClose={() => setShowModal(false)}
          onSuccess={() => setCanRequestRefund(false)}
        />
      )}
    </>
  );
}
